import { useTranslation } from 'next-i18next';
import { useLocale } from '@/hooks';
import { Button } from '@/ui_v3';
import { cn } from '@/utils';
import { handleContactSalesClick } from '../../utils';
import { Videos } from './Videos';
export const BizCta = () => {
  return <section className={cn('flex flex-col items-center bg-gradient-to-b from-white to-gray-100', 'pt-2xl pb-lg px-[16px] min-[751px]:pt-3xl min-[751px]:pb-2xl min-[751px]:px-[24px] min-[1025px]:pb-4xl min-[1025px]:px-[40px]')} data-sentry-component="BizCta" data-sentry-source-file="BizCta.tsx">
      <Title data-sentry-element="Title" data-sentry-source-file="BizCta.tsx" />
      <Buttons data-sentry-element="Buttons" data-sentry-source-file="BizCta.tsx" />
      <Videos data-sentry-element="Videos" data-sentry-source-file="BizCta.tsx" />
    </section>;
};
const Title = () => {
  const {
    t
  } = useTranslation(['bizLanding']);
  return <div className="flex flex-col items-center" data-sentry-component="Title" data-sentry-source-file="BizCta.tsx">
      <h1 className="flex flex-col items-center text-center text-display-md-extrabold">
        <p>{t('biz-landing.cta.title')}</p>
      </h1>
      <img src="/assets/ZEPQuizBiz-logo.webp" alt="ZEP Quiz for Biz" className="w-[278px]" />
    </div>;
};
const Buttons = () => {
  const {
    t
  } = useTranslation(['bizLanding']);
  const {
    locale
  } = useLocale();
  return <div className="mb-2xl mt-[30px] flex items-center gap-2xs" data-sentry-component="Buttons" data-sentry-source-file="BizCta.tsx">
      <Button variant="contained" intent="strong" size="lg" rounded="default" onClick={() => handleContactSalesClick(locale)} data-sentry-element="Button" data-sentry-source-file="BizCta.tsx">
        {t('biz-landing.cta.button')}
      </Button>
    </div>;
};